import { render, staticRenderFns } from "./OwnAsset.vue?vue&type=template&id=d8978f36"
import script from "./OwnAsset.vue?vue&type=script&lang=js"
export * from "./OwnAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports